"use client"

import type React from "react"

interface ClientProgressBarProps {
  percentage: number
  score: number
  average: number
}

export const ClientProgressBar: React.FC<ClientProgressBarProps> = ({ percentage, score, average }) => {
  return (
    <div className="space-y-1">
      <div className="relative h-6 rounded bg-gray-200">
        <div
          style={{
            width: `${percentage}%`,
          }}
          className="h-full bg-blue-500 rounded-r-full relative"
        >
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-white text-xs font-semibold">
            {score.toFixed(1)}
          </span>
        </div>
        <div
          style={{
            left: `${Math.min((average / 10) * 100, 100)}%`,
          }}
          className="absolute inset-y-0 w-0.5 bg-yellow-400"
        />
      </div>
      <div className="text-right text-xs text-gray-500">Genomsnitt: {average.toFixed(1)}</div>
    </div>
  )
}

